import { Suspense, use } from 'react';

import { useFullRemoteTheme } from '@eduzz/ui-antd-theme';

import { ThemeContext } from './ThemeProvider';

// The `default` remote theme ships no `logos` map (only `facelift` does), so
// before the facelift window we fall back to the same brand assets that
// `@eduzz/ui-layout` defaults to.
const FALLBACK_LOGOS = {
  light: 'https://cdn.eduzzcdn.com/topbar/brand/eduzz.svg',
  dark: 'https://cdn.eduzzcdn.com/topbar/brand/eduzz-dark.svg'
};

type LogoProps = {
  className?: string;
};

const RemoteLogo = ({ className, fallbackSrc }: LogoProps & { fallbackSrc: string }) => {
  const { theme } = use(ThemeContext);
  const logos = useFullRemoteTheme()?.logos?.eduzz;
  const src = (theme === 'dark' ? logos?.logoDarkMode : logos?.logo) ?? fallbackSrc;

  return <img className={className} src={src} alt='Eduzz' />;
};

// `useFullRemoteTheme` reads a suspending resource, and `Header` is rendered
// inside a Suspense fallback in `RegistryBootstrap` — where suspending would
// escape to the parent boundary. Keeping the boundary here makes the logo safe
// to drop anywhere.
export const Logo = ({ className }: LogoProps) => {
  const { theme } = use(ThemeContext);
  const fallbackSrc = theme === 'dark' ? FALLBACK_LOGOS.dark : FALLBACK_LOGOS.light;

  return (
    <Suspense fallback={<img className={className} src={fallbackSrc} alt='Eduzz' />}>
      <RemoteLogo className={className} fallbackSrc={fallbackSrc} />
    </Suspense>
  );
};
